/**
 * converte a array passada para uma estrutura de objeto
 * @param {*} array array que será convertida em objeto
 * @param {*} fieldKeyGenerator function cuja responsabilidade é retornar a key
 * que será utilizada para mapear o item do array. Esta function recebe, por parâmetro,
 * o item correspondente da array e o índice apontando para a posição do mesmo na array.
 */
export function toMap(array, fieldKeyGenerator) {
  return array.map((arrayItem, index) => {
    const entry = {};
    const key = fieldKeyGenerator(arrayItem, index);
    entry[key] = arrayItem;
    return entry;
  })
    .reduce((reduced, next) => ({ ...reduced, ...next }));
}

export function groupBy(array, groupByKey) {
  return array.reduce((reduced, next) => {
    (reduced[next[groupByKey]] = reduced[next[groupByKey]] || []).push(next);
    return reduced;
  }, {});
}
